import React from 'react';
import A from '../a';
import './styles.css';

const Button = props => {
  const { className = '' } = props;

  if (props.href) {
    return (
      <A {...props} className={`Button ${className}`}>
        {props.children}
      </A>
    );
  }

  return (
    <button {...props} className={`Button ${className}`}>
      {props.children}
    </button>
  );
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/views/components/button/index.js
 **/